// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".shipping-schedule-form-dialog .form-flex {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n.shipping-schedule-form-dialog textarea.el-textarea__inner {\n  min-height: 80px !important;\n}\n", ""]);
// Exports
module.exports = exports;
